<template>
  <div class="version">
    <div class="version__copyright">EdgeFirst Studio, {{ productVersion }}</div>
    <div class="version__copyright">Au-Zone Technologies</div>
    <div class="version__detail">Backend: {{ formattedBackendVersion }}</div>
    <div class="version__detail">Frontend: {{ formattedFrontendVersion }}</div>
    <a href="/terms" class="version__terms">Terms of service</a>
  </div>
</template>

<script>
function getVersionParts(value) {
  const version = String(value || '').match(/\d+/g) || [];
  return version;
}

function formatVersion(value, partCount) {
  const parts = getVersionParts(value).slice(0, partCount);
  return parts.length ? parts.join('.') : '-';
}

function formatVersionWithHash(value) {
  const version = String(value || '').trim();
  const baseMatch = version.match(/\d+(?:\.\d+){0,2}/);

  if (!baseMatch) {
    return '-';
  }

  const baseVersion = baseMatch[0];
  const hash = version
    .slice(baseMatch.index + baseVersion.length)
    .trim()
    .replace(/^[.:\-+_~\s()]+/, '')
    .replace(/[()\s]/g, '');

  return hash ? `${baseVersion}-${hash}` : baseVersion;
}

export default {
  name: 'AppVersion',
  props: {
    backendVersion: {
      type: String,
      default: '',
    },
    frontendVersion: {
      type: String,
      default: '',
    },
  },
  computed: {
    productVersion() {
      return formatVersion(this.backendVersion || this.frontendVersion, 2);
    },
    formattedBackendVersion() {
      return formatVersionWithHash(this.backendVersion);
    },
    formattedFrontendVersion() {
      return formatVersionWithHash(this.frontendVersion);
    },
  },
};
</script>

<style lang="scss" scoped>
.version {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 12px;
  color: $color-primary;
  font-size: 12px;
  line-height: 1.45;
}

.version__copyright,
.version__product {
  color: $color-primary;
  font-weight: 700;
}

.version__detail {
  margin-left: 12px;
  color: #555;
  font-size: 11px;
  font-style: italic;
  font-weight: 400;
}

.version__terms {
  color: #363636 !important;
  text-decoration: none;
}

.version__terms:hover {
  text-decoration: underline;
}
</style>
